import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { MainPageLayout } from '#apps/client-web/app/components/main-page-layout';
import { useNavigateReload } from '#apps/client-web/app/hooks/use-nagivate-reload';
import { appSettingsService } from '#apps/client-web/features/settings/services/app-settings';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';

import { UserSettingsPageContainer } from './app-settings-page.container';
import { useAppSettingsPageViewModel } from './app-settings-page.view-model';

export const AppSettingsPage = () => {
  const logger = useLogger('pages/app-settings');

  const onReload = useNavigateReload({ logger });
  const viewModel = useAppSettingsPageViewModel({
    appSettingsService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <MainPageLayout
      title="User Settings"
      onErrorActionClick={onReload}
      pageContentProps={{ maxWidth: 'sm' }}>
      <UserSettingsPageContainer viewModel={viewModel} logger={logger} />
    </MainPageLayout>
  );
};
